import coverImageMilk from "../../../assets/images/milk/milkCategoryCoverImage.webp";
import milkCategoryCoverImageMobile from '../../../assets/images/milk/milkCategoryCoverImageMobile.webp'
import milkImage1 from '../../../assets/images/milk/milkImage1.webp'

export const MilkProductsArr = [
    {
        path: "/milk/milk-ukrainian-2-5-fat-mumulya-900g/",
        category: "milk",
        metaTitle: "Молоко Мумуля",
        metaDescription: "Молоко питне пастеризоване «Українське» 2,5 % жиру ТМ «МУМУЛЯ» 900 g (г)",
        coverImage: coverImageMilk,
        coverImageMobile: milkCategoryCoverImageMobile,
        coverTitle: "Молоко Пастеризоване",
        aboutImage: milkImage1,
        aboutTitle: "Молоко питне пастеризоване «Українське» 2,5 % жиру ТМ «МУМУЛЯ» 900 g (г)",
        aboutStats: [
            "3,0 g (г)", "2,5 g (г)", "4,5 g (г)", "57 kcal (ккал)"
        ],
        aboutLink: "",
        aboutInformation: [
            {
                title: "Маса/Об'єм:",
                desc: "900 g (г)",
            },
            {
                title: "Пакування:",
                desc: "Плівка",
            },
            {
                title: "Склад:",
                desc: "молоко коров’яче незбиране, молоко коров’яче знежирене.",
            },
            {
                title: "Термін придатності:",
                desc: "Зберігати при температурі (4 ± 2) °C не більше ніж 7 діб від дати виробництва.",
            },
            {
                title: "Сертифікат якості:",
                desc: "ТУ У 25027034-008-98",
            },
        ],
        categoryInfo: [
            "Ретельний контроль сирого молока та фермерських господарств.",
            "Бактеріологічна чистота молока  - результат пастеризації та термічної обробки та дотримання санітарних норм.",
            "Чистий натуральний молочний смак коров’ячого молока.",

        ]
    },
]